import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormControl, FormGroup} from '@angular/forms';
import {Store} from "@ngrx/store";
import {debounceTime, Subject, takeUntil} from "rxjs";
import {getRelatedResources} from "../../core/resources-hub.selectors";
import {ResourceResponseData} from "../../model/resource-model";
import {FetchRelatedResourcesRequest} from "../../core/resources-hub.actions";
import { Router } from '@angular/router';
import { CommonService } from 'src/app/modules/shared/services/common.service';


@Component({
  selector: 'app-related-resources',
  templateUrl: './related-resources.component.html',
  styleUrls: ['./related-resources.component.css']
})
export class RelatedResourcesComponent implements OnInit, OnDestroy {
  relatedResources: FormGroup = new FormGroup<any>({
    resourceSearchedText: new FormControl('')
  })
  loading: boolean = false;
  paginationRelatedLoading: boolean = false
  dataSource: any[] = [];
  displayedColumns = [
    'title',
    'category',
    'subCategories',
  ];
  relatedResourceData: ResourceResponseData = {}
  throttle = 300;
  scrollDistance = 0.01;
  scrollUpDistance = 0.01;
  selectedResources: any[] = [];
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(
    private matDialogRef: MatDialogRef<RelatedResourcesComponent>, 
    @Inject(MAT_DIALOG_DATA) public data: any, 
    private store: Store,
    private router:Router,
    private commonService:CommonService
    ) {
  }

  ngOnInit(): void {
    if (this.data && this.data.relatedResources) {
      this.selectedResources = [...this.data.relatedResources];
    }
    this.store.select(getRelatedResources).pipe(takeUntil(this.onDestroy))
      .subscribe(relatedResourceResponse => {
        this.relatedResourceData = relatedResourceResponse.list;
        this.loading = relatedResourceResponse.loading;
        if (!relatedResourceResponse.loading) {
          this.paginationRelatedLoading = false;
        }
        if (this.relatedResourceData?.list?.length > 0) {
          this.dataSource = [...this.relatedResourceData.list];
        }
        this.setInitialData();
      })

    this.relatedResources.valueChanges.pipe(debounceTime(1000), takeUntil(this.onDestroy))
      .subscribe(values => {
        this.store.dispatch(FetchRelatedResourcesRequest({
          payload: {
            pageNumber: 1,
            filters: {
              searchText: values.resourceSearchedText
            }
          }
        }))
      })
  }

  resourceAlreadySelectedMapper() {
    if (this.selectedResources) {
      const updatedDataSource: any[] = [];
      this.dataSource.forEach((dataSource: any, index: number) => {
        let relatedResource = {...dataSource, checked: false}
        this.selectedResources.forEach(resource => {
          if (resource.id === dataSource.id) {
            relatedResource.checked = true;
          }
        })
        updatedDataSource.push(relatedResource);
        if (index + 1 === this.dataSource.length) {
          this.dataSource = [...updatedDataSource];
        }
      })
    }
  }

  setInitialData() {
    let pushedIds = []
    let data = [];
    this.selectedResources.forEach((selected: any) => {
      data.push({...selected, checked: true});
      pushedIds.push(selected.id);
    })
    this.dataSource.forEach((resourceItem: any) => {
      if (!pushedIds.includes(resourceItem.id)) {
        data.push({...resourceItem, checked: false});
        pushedIds.push(resourceItem.id);
      }
    })
    this.dataSource = [...data]
  }

  conformButtonClicked() {
    this.matDialogRef.close({
      data: this.selectedResources,
      type: 'confirm'
    })
  }

  closeButtonClickHandler() {
    this.matDialogRef.close({
      type: 'close'
    })
  }

  onAddRelatedResource(event: any, index: number, resource: any): void {
    if (event.checked) {
      this.selectedResources.push(resource);
      this.resourceAlreadySelectedMapper();
    } else {
      const indexToBeRemoved = this.selectedResources.findIndex(selectedResource => selectedResource.id === resource.id)
      if (indexToBeRemoved >= 0) {
        this.selectedResources.splice(indexToBeRemoved, 1);
        this.resourceAlreadySelectedMapper();
      }
    }
  }

  getNext(): void {
    this.paginationRelatedLoading = true;
    if (this.relatedResourceData.hasNext) {
      this.store.dispatch(FetchRelatedResourcesRequest({
        payload: {
          pageNumber:
            this.relatedResourceData.pageNumber + 1,
          filters: {searchText: this.relatedResources.value.resourceSearchedText,}
        }
      }));
    }
  }

  getCategoriesName(categories: any[]): string {
    if (categories && categories?.length > 0) {
      return categories.map(category => category.value).join(', ')
    } else {
      return ''
    }
  }

  getSubCategoriesName(categories: any[]) {
    if (categories && categories?.length > 0) {
      return categories.map(category => category.subCategories.map(subCategories => subCategories.value)
        .join(', ')).join(', ')
    } else {
      return ''
    }
  }

  openRelatedResource(data){
    const urlPrefix = this.router.url.split('/')[1];
    this.commonService.openInNewTab(`/${urlPrefix}/resource-hub/resource-details/${data.id}/${data.slug}`)
  }

  ngOnDestroy(): void {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
